import styled from 'styled-components';
import { ThemeColours } from '../../../../../../../common/styles/ThemeColours';
import { FONT_STACK } from '../../../../../../../common/styles/constants';
import { onMobile } from '../../../../../../../common/styles/onMobile';

export const Text = styled.p`
  ${onMobile} {
    ${FONT_STACK}
    color: ${ThemeColours.mono700};
    font-size: 14px;
    line-height: 21px;
    text-align: left;
  }
`;

export const ListContainer = styled.ul`
  ${onMobile} {
    ${FONT_STACK}
    color: ${ThemeColours.mono700};
    font-size: 14px;
    line-height: 21px;
    padding-inline-start: 18px;
    text-align: left;
  }
`;

export const Header = styled.p`
  ${onMobile} {
    ${FONT_STACK}
    color: ${ThemeColours.black};
    font-size: 24px;
  }
`;
